import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import DtcDecoder from '../components/tools/dtcDecoder/DtcDecoder';
import { Alert, AlertTitle, AlertDescription } from '../components/ui/alert';
import { Info } from 'lucide-react';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'DTC & Status Byte Decoder – UDS 0x19 and OBD-II PID Decoder | AUTOXIUM';
const PAGE_DESCRIPTION = 'Decode DTCs (P0301 ↔ bytes), Failure Type Bytes, ISO 14229-1 DTC status bytes, UDS 0x19 ReadDTCInformation responses and OBD-II Mode 01/03/09 responses, with formulas shown.';

const DtcDecoderPage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <div className="min-h-screen" data-testid="dtc-decoder-page">
      <PageHero
        eyebrow="Diagnostic Tools"
        title="DTC & Status Byte Decoder"
        description="Decode DTC codes and bytes, the ISO 14229-1 status byte, full UDS 0x19 responses and OBD-II PID responses — paste anything and the tool works out what it is."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="dtc-decoder-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8 space-y-6">
          <Alert data-testid="dtc-decoder-disclaimer">
            <Info className="h-4 w-4" />
            <AlertTitle className="font-chivo uppercase tracking-tight text-sm">Applicability Note</AlertTitle>
            <AlertDescription>
              DTC structure follows SAE J2012 / ISO 15031-6, status bits follow ISO 14229-1, and
              OBD-II formulas follow SAE J1979. Descriptions cover about 170 common generic codes,
              written in our own words. Manufacturer-specific codes, FTB sub-types that could not be
              verified from public sources, snapshot/extended-data layouts, and confirmation/ageing
              thresholds are OEM-defined and are labelled as such, never guessed. Check the target
              ECU&apos;s own diagnostic specification before relying on a result for real repairs.
            </AlertDescription>
          </Alert>

          <DtcDecoder />
          <ToolGuideCta guidePath="/tools/diagnostic/dtc-decoder/guide" toolName="DTC & Status Byte Decoder" />
        </div>
      </section>
    </div>
  );
};

export default DtcDecoderPage;
